import React from "react";

// Single source of truth for rendering a PDF page <img>.
//
// Both the standalone helper (Functions/index.js -> getImageStructure) and the
// viewer instance method (Functions/viewer.js -> this.getImageStructure) build
// their URLs differently (the viewer maps child-PDF page numbers), so they pass
// the already-built sources in here and share the rendering/fallback rules:
//
//   - use the AVIF variant only when the PDF is AVIF-enabled AND the browser
//     advertised AVIF support (checkAvifSupport stored that in localStorage at
//     startup),
//   - always fall back to JPEG when the chosen source fails to load.
export const buildImageStructure = ({
	jpegSrc,
	avifSrc,
	alt,
	lazy = false,
	classname,
}) => {
	const useAvif =
		Boolean(avifSrc) && localStorage.getItem("avifSupport") === "true";
	const src = useAvif ? avifSrc : jpegSrc;

	return (
		<img
			src={src}
			alt={alt}
			{...(lazy ? { loading: "lazy" } : {})}
			{...(classname ? { className: classname } : {})}
			onError={(e) => {
				// Fall back to JPEG. Comparing against the resolved src keeps this
				// from looping when the JPEG itself 404s, without permanently
				// detaching the handler (the same <img> node is reused when React
				// swaps in another page).
				if (e.target.src !== jpegSrc) e.target.src = jpegSrc;
			}}
		/>
	);
};

export default buildImageStructure;
